<template>
  <v-col cols="12">
    <template v-if="filterData.length == 0">
      <img v-bind:src="require('../../../assets/loading/loading.gif')" />
    </template>
    <template v-else>
      <b>Seller Profit {{ report_month }}</b>

      <v-col>
        <v-btn
          color="info"
          @click="exportToExcel"
          v-if="checkRoles('General Manager') || checkRoles('Administrator')"
          >Export To Excel</v-btn
        >
      </v-col>

      <!-- <v-col cols="12" v-if="manager || admin || username == 'linhlt'"> -->
      <v-col cols="12">
        <template v-for="(i, index) in filterData">
          <v-btn
            text
            small
            @click="
              selectedFilter = i;
              filterDataTable(selectedFilter);
            "
            :key="index"
            >{{ i }}</v-btn
          >
          &nbsp;
        </template>
      </v-col>

      <template v-if="report_type == 'store_profit'">
        <v-col cols="12" v-if="this.$cookies.get('stores') != null">
          <template v-for="(i, index) in listUserStores">
            <v-btn
              text
              small
              @click="
                selectedFilter = i;
                filterDataTable(selectedFilter);
              "
              :key="index"
              >{{ i }}</v-btn
            >
            &nbsp;
          </template>
        </v-col>
      </template>

      <!-- <v-col cols="12" v-if="!marketing">
                <v-btn text small @click="selectedFilter = username;filterDataTable(selectedFilter)" :key="index">{{username}}</v-btn>
        </v-col> -->

      <div>
        <b>{{ selectedFilter }}</b>
      </div>

      <template v-if="selectedData.length == 0"> No Data Available </template>
      <table class="table table-striped" v-else>
        <thead class="thead-light">
          <tr>
            <th>Day Of Month</th>
            <th title="Total Order In Day">Total Order In Day</th>
            <th>Total Sales In Day</th>
            <th
              title="item revenue = (item price x item quantity) - item discount
                    + item shipping + item tip"
            >
              Revenue
            </th>
            <th
              title="item temp profit = item revenue - 0.1 x item revenue
                    - item temp base cost"
            >
              Temp Profit
            </th>
            <th
              title="item gross profit = item revenue - 0.1 x item revenue
                     - item real base cost"
            >
              Gross Profit
            </th>
            <th
              title="Facebook Ad Spent = Product Ad Spent + Seller Ad Spent + Store Ad Spent"
            >
              Facebook Ad Spent
            </th>
            <th
              title="Google Ad Spent = Product Ad Spent + Seller Ad Spent + Store Ad Spent"
            >
              Google Ad Spent
            </th>
            <th title="Total Ad Spent = Facebook Ad Spent + Google Ad Spent">
              Total Ad Spent
            </th>
            <th
              title="item net profit = item gross profit - item total ad spent"
            >
              Net Profit
            </th>
            <th title="ROI = item net profit x 100 / item total ad spent">
              ROI
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, text, index) in selectedData" :key="index">
            <template
              v-if="
                text != 'total_orders_in_month' &&
                text != 'total_revenue' &&
                text != 'total_temp_profit' &&
                text != 'total_gross_profit' &&
                text != 'total_facebook_ad_spent' &&
                text != 'total_google_ad_spent' &&
                text != 'total_net_profit' &&
                text != 'overall_roi' &&
                text != 'total_ad_spent' &&
                text != 'total_sales_in_month'
              "
            >
              <td>{{ text }}</td>
              <td>{{ value.total_orders_in_day }}</td>
              <td>{{ value.total_sales_in_day }}</td>
              <td>{{ parseFloat(value.revenue).toFixed(2) }}</td>
              <td>{{ parseFloat(value.temp_profit).toFixed(2) }}</td>
              <td>{{ parseFloat(value.gross_profit).toFixed(2) }}</td>
              <td>{{ parseFloat(value.facebook_ad_spent).toFixed(2) }}</td>
              <td>{{ parseFloat(value.google_ad_spent).toFixed(2) }}</td>
              <td>{{ parseFloat(value.total_ad_spent).toFixed(2) }}</td>
              <td>{{ parseFloat(value.net_profit).toFixed(2) }}</td>
              <td v-if="value.roi">{{ parseFloat(value.roi).toFixed(2) }}%</td>
              <td v-else>NaN</td>
            </template>
          </tr>
          <tr>
            <td><b>Total</b></td>
            <td>
              <b>{{ selectedData.total_orders_in_month }}</b>
            </td>
            <td>
              <b>{{ selectedData.total_sales_in_month }}</b>
            </td>
            <td>
              <b>{{ parseFloat(selectedData.total_revenue).toFixed(2) }}</b>
            </td>
            <td>
              <b>{{ parseFloat(selectedData.total_temp_profit).toFixed(2) }}</b>
            </td>
            <td>
              <b>{{
                parseFloat(selectedData.total_gross_profit).toFixed(2)
              }}</b>
            </td>
            <td>
              <b>{{
                parseFloat(selectedData.total_facebook_ad_spent).toFixed(2)
              }}</b>
            </td>
            <td>
              <b>{{
                parseFloat(selectedData.total_google_ad_spent).toFixed(2)
              }}</b>
            </td>
            <td>
              <b>{{ parseFloat(selectedData.total_ad_spent).toFixed(2) }}</b>
            </td>
            <td>
              <b>{{ parseFloat(selectedData.total_net_profit).toFixed(2) }}</b>
            </td>
            <td v-if="selectedData.overall_roi">
              <b>{{ parseFloat(selectedData.overall_roi).toFixed(2) }}%</b>
            </td>
            <td v-else><b>NaN</b></td>
          </tr>
        </tbody>
      </table>
    </template>
  </v-col>
</template>

<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
import XLSX from "xlsx";
import moment from "moment";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "StoreSellerProfit",
  props: {
    report_type: String,
    report_month: String,
    // marketing: Boolean,
    // manager: Boolean,
    // admin: Boolean,
  },
  data: () => ({
    reportData: [],
    filterData: [],
    selectedFilter: "",
    selectedData: [],
    username: "",
    listUserStores: null,
    convertData: {},
  }),
  created() {
    this.$root.$refs.storeSellerReport = this;
  },
  methods: {
    async loadData() {
      this.reportData = [];
      this.filterData = [];
      this.selectedFilter = "";
      this.selectedData = [];

      var queryParams = {
        report_month: this.report_month,
        report_type: this.report_type,
      };

      var currentSession = await this.$root.$refs.App.currentSession(
        "profit-store-seller-loadData"
      );

      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/profit?", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            // console.log(this.AuthStr)
            console.log(response);
            this.reportData = response.data.data;
            console.log("this.reportData: ", this.reportData);
            for (const i in this.reportData) {
              this.filterData.push(i);
            }

            // if (currentSession.username == "linhlt") {
            //   this.username = currentSession.username;
            // }

            // if (this.marketing && !this.manager) {
            //   this.selectedFilter = currentSession.username;
            //   this.filterDataTable(this.selectedFilter);
            // }

            console.log("this.filterData: ", this.filterData);

            if (this.$cookies.get("stores") != null) {
              this.listUserStores = this.$cookies.get("stores").split(",");
            }
            console.log("this.listUserStores: ", this.listUserStores);
            this.convertDataJSON();
          })
          .catch((error) => {
            console.log("Error:", error);
            this.loading = false;
          });
      } else {
        console.log("profit-store-seller-loadData-undefined: ", currentSession);
      }
    },

    convertDataJSON() {
      if (this.listUserStores != null)
        for (const i of this.listUserStores) {
          this.convertData[i] = this.reportData[i];
        }
      else {
        this.convertData = JSON.parse(JSON.stringify(this.reportData));
      }
      //this.convertData = JSON.parse(JSON.stringify(this.reportData));
      console.log("this.convertData: ", this.convertData);
      for (const a in this.convertData) {
        this.convertData[a] = [];
      }
      for (var b in this.reportData) {
        //console.log(b)
        var totalTemp = {
          DayOfMonth: "Total",
        };
        for (var c in this.reportData[b]) {
          //console.log(parseInt(c))
          var num = parseInt(c);
          var data = {};
          if (!isNaN(num)) {
            data["DayOfMonth"] = c;

            for (var d in this.reportData[b][c]) {
              data[d] = this.reportData[b][c][d];
            }
            this.convertData[b].push(data);
          } else {
            totalTemp[c] = this.reportData[b][c];
          }
        }
        var total = {
          DayOfMonth: "Total",
          total_orders_in_day: totalTemp.total_orders_in_month,
          total_sales_in_day: totalTemp.total_sales_in_month,
          revenue: totalTemp.total_revenue,
          temp_profit: totalTemp.total_temp_profit,
          gross_profit: totalTemp.total_gross_profit,
          facebook_ad_spent: totalTemp.total_facebook_ad_spent,
          google_ad_spent: totalTemp.total_google_ad_spent,
          total_ad_spent: totalTemp.total_ad_spent,
          net_profit: totalTemp.total_net_profit,
          roi: totalTemp.overall_roi,
        };
        this.convertData[b].push(total);
      }
    },

    exportToExcel() {
      // On Click Excel download button
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      for (const a in this.convertData) {
        var b = XLSX.utils.json_to_sheet(this.convertData[a]);
        XLSX.utils.book_append_sheet(wb, b, a);
      }

      // add Worksheet to Workbook
      var current = moment().format("YYYY-MM-DD-h-mm-ss");
      // export Excel file
      XLSX.writeFile(
        wb,
        this.report_type + "_" + this.report_month + "_" + current + ".xlsx"
      ); // name of the file is 'book.xlsx'
    },

    filterDataTable(value) {
      if (this.reportData[value]) {
        this.selectedData = this.reportData[value];
      } else {
        this.selectedData = [];
      }
      console.log("this.selectedData: ", this.selectedData);
    },

    clearFilter() {
      console.log("clearFilter");
      this.reportData = [];
      this.filterData = [];
      this.selectedFilter = "";
      this.selectedData = [];
      this.loadData();
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    console.log("Show Report");
    console.log(this.report_type);
    console.log(this.report_month);
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
th {
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
}
</style>